// extracted by mini-css-extract-plugin
export default {"main":"VideoModal_main__llPrq"};